'use strict';

angular.module('bringgApp').constant('ROGUE_REASONS', {
	TIME_WINDOW: 0,
	CAPACITY: 1
});
